module.exports = __webpack_public_path__ + "img/campinas-em-revista.94d57b1d.png";